export const routes = [
  {
    path: '/bbs',
    /* internal name: '/bbs' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bbs/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs/index.vue'),
        /* no children */
        meta: {
          "title": "论坛",
          "i18n": "menus.mall",
          "showFooter": true
        }
      },
      {
        path: 'detail',
        /* internal name: '/bbs/detail' */
        /* no component */
        children: [
          {
            path: '',
            name: '/bbs/detail/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs/detail/index.vue'),
            /* no children */
            meta: {
              "title": "详情",
              "i18n": "menus.mall",
              "showFooter": false
            }
          }
        ],
      },
      {
        path: 'index1',
        name: '/bbs/index1',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs/index1.vue'),
        /* no children */
        meta: {
          "title": "论坛",
          "i18n": "menus.mall",
          "showFooter": true,
          "hideHeader": true,
          "backgroundColor": "#fff"
        }
      },
      {
        path: 'publish',
        /* internal name: '/bbs/publish' */
        /* no component */
        children: [
          {
            path: '',
            name: '/bbs/publish/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs/publish/index.vue'),
            /* no children */
            meta: {
              "title": "发帖",
              "i18n": "menus.mall",
              "showFooter": false,
              "backgroundColor": "#fff"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/bbs-old',
    /* internal name: '/bbs-old' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bbs-old/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs-old/index.vue'),
        /* no children */
      },
      {
        path: 'detail',
        /* internal name: '/bbs-old/detail' */
        /* no component */
        children: [
          {
            path: '',
            name: '/bbs-old/detail/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/bbs-old/detail/index.vue'),
            /* no children */
            meta: {
              "title": "详情",
              "i18n": "menus.mall",
              "showFooter": false,
              "hideHeader": false,
              "backgroundColor": "#fff"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/deliver_address',
    /* internal name: '/deliver_address' */
    /* no component */
    children: [
      {
        path: '',
        name: '/deliver_address/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/deliver_address/index.vue'),
        /* no children */
        meta: {
          "title": "收货地址",
          "i18n": "menus.deliverAddress"
        }
      }
    ],
  },
  {
    path: '/directive-test',
    /* internal name: '/directive-test' */
    /* no component */
    children: [
      {
        path: '',
        name: '/directive-test/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/directive-test/index.vue'),
        /* no children */
        meta: {
          "title": "自定义指令"
        }
      }
    ],
  },
  {
    path: '/error',
    /* internal name: '/error' */
    /* no component */
    children: [
      {
        path: '403',
        /* internal name: '/error/403' */
        /* no component */
        children: [
          {
            path: '',
            name: '/error/403/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/error/403/index.vue'),
            /* no children */
            meta: {
              "title": "403页面",
              "i18n": "menus.fzt"
            }
          }
        ],
      },
      {
        path: '404',
        /* internal name: '/error/404' */
        /* no component */
        children: [
          {
            path: '',
            name: '/error/404/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/error/404/index.vue'),
            /* no children */
            meta: {
              "title": "404页面",
              "i18n": "menus.fzf"
            }
          }
        ],
      },
      {
        path: '500',
        /* internal name: '/error/500' */
        /* no component */
        children: [
          {
            path: '',
            name: '/error/500/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/error/500/index.vue'),
            /* no children */
            meta: {
              "title": "500页面",
              "i18n": "menus.fzz"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/goldingot',
    /* internal name: '/goldingot' */
    /* no component */
    children: [
      {
        path: '',
        name: '/goldingot/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/goldingot/index.vue'),
        /* no children */
        meta: {
          "title": "我的元宝",
          "i18n": "menus.info",
          "showFooter": false,
          "showBackground": false,
          "backgroundColor": "#ffffff"
        }
      }
    ],
  },
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '',
        name: '/home/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/home/index.vue'),
        /* no children */
        meta: {
          "title": "首页",
          "i18n": "menus.home",
          "showFooter": true
        }
      }
    ],
  },
  {
    path: '/integral',
    /* internal name: '/integral' */
    /* no component */
    children: [
      {
        path: '',
        name: '/integral/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/integral/index.vue'),
        /* no children */
        meta: {
          "title": "我的积分",
          "i18n": "menus.info",
          "showFooter": false,
          "showBackground": false,
          "backgroundColor": "#ffffff"
        }
      },
      {
        path: 'exchange',
        /* internal name: '/integral/exchange' */
        /* no component */
        children: [
          {
            path: '',
            name: '/integral/exchange/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/integral/exchange/index.vue'),
            /* no children */
            meta: {
              "title": "兑换积分",
              "i18n": "menus.info",
              "showFooter": false,
              "showBackground": false,
              "backgroundColor": "#ffffff"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/login/index.vue'),
        /* no children */
        meta: {
          "title": "登录页",
          "i18n": "menus.login",
          "showBackground": true,
          "backgroundColor": "#fff"
        }
      },
      {
        path: 'auto',
        /* internal name: '/login/auto' */
        /* no component */
        children: [
          {
            path: '',
            name: '/login/auto/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/login/auto/index.vue'),
            /* no children */
            meta: {
              "title": "登录页",
              "hideHeader": true,
              "showBackground": false
            }
          }
        ],
      }
    ],
  },
  {
    path: '/mall',
    /* internal name: '/mall' */
    /* no component */
    children: [
      {
        path: '',
        name: '/mall/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mall/index.vue'),
        /* no children */
        meta: {
          "title": "商城",
          "i18n": "menus.mall",
          "showFooter": true,
          "hideHeader": true,
          "backgroundColor": "#fff"
        }
      },
      {
        path: 'detail',
        /* internal name: '/mall/detail' */
        /* no component */
        children: [
          {
            path: '',
            name: '/mall/detail/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mall/detail/index.vue'),
            /* no children */
            meta: {
              "title": "商品详情",
              "i18n": "menus.mall",
              "showFooter": false,
              "hideHeader": false,
              "backgroundColor": "#fff"
            }
          },
          {
            path: 'index1',
            name: '/mall/detail/index1',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mall/detail/index1.vue'),
            /* no children */
            meta: {
              "title": "商品详情",
              "i18n": "menus.mall",
              "showFooter": false,
              "hideHeader": false
            }
          }
        ],
      },
      {
        path: 'index1',
        name: '/mall/index1',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mall/index1.vue'),
        /* no children */
        meta: {
          "title": "商城",
          "i18n": "menus.mall",
          "showFooter": true,
          "hideHeader": true
        }
      },
      {
        path: 'index2',
        name: '/mall/index2',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mall/index2.vue'),
        /* no children */
        meta: {
          "title": "商城",
          "i18n": "menus.mall",
          "showFooter": true,
          "hideHeader": true
        }
      }
    ],
  },
  {
    path: '/message',
    /* internal name: '/message' */
    /* no component */
    children: [
      {
        path: '',
        name: '/message/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/message/index.vue'),
        /* no children */
        meta: {
          "title": "消息",
          "i18n": "menus.message",
          "showFooter": true
        }
      },
      {
        path: ':id',
        /* internal name: '/message/[id]' */
        /* no component */
        children: [
          {
            path: ':name',
            /* internal name: '/message/[id]/[name]' */
            /* no component */
            children: [
              {
                path: '',
                name: '/message/[id]/[name]/',
                component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/message/[id]/[name]/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/mlottery',
    /* internal name: '/mlottery' */
    /* no component */
    children: [
      {
        path: '',
        name: '/mlottery/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mlottery/index.vue'),
        /* no children */
        meta: {
          "title": "抽奖",
          "i18n": "menus.lottery",
          "hideHeader": true,
          "navbarFontColor": "#fff"
        }
      },
      {
        path: 'index1',
        name: '/mlottery/index1',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/mlottery/index1.vue'),
        /* no children */
        meta: {
          "title": "抽奖",
          "i18n": "menus.lottery",
          "showBackground": false,
          "hideHeader": true
        }
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/index.vue'),
        /* no children */
        meta: {
          "title": "个人中心",
          "i18n": "menus.info",
          "showFooter": true,
          "showBackground": true,
          "backgroundColor": "#f5f6f7"
        }
      },
      {
        path: 'bbs',
        /* internal name: '/profile/bbs' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/bbs/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/bbs/index.vue'),
            /* no children */
            meta: {
              "title": "我的帖子",
              "i18n": "menus.prizes"
            }
          }
        ],
      },
      {
        path: 'collect',
        /* internal name: '/profile/collect' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/collect/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/collect/index.vue'),
            /* no children */
            meta: {
              "title": "我的收藏",
              "i18n": "menus.collect"
            }
          }
        ],
      },
      {
        path: 'info',
        /* internal name: '/profile/info' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/info/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/info/index.vue'),
            /* no children */
            meta: {
              "title": "商品详情",
              "i18n": "menus.mall",
              "showFooter": false,
              "hideHeader": false,
              "backgroundColor": "#fff"
            }
          }
        ],
      },
      {
        path: 'order',
        /* internal name: '/profile/order' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/order/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/order/index.vue'),
            /* no children */
            meta: {
              "title": "我的订单",
              "i18n": "menus.orders"
            }
          }
        ],
      },
      {
        path: 'prize',
        /* internal name: '/profile/prize' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/prize/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/prize/index.vue'),
            /* no children */
            meta: {
              "title": "我的奖品",
              "i18n": "menus.prizes"
            }
          }
        ],
      },
      {
        path: 'templete',
        /* internal name: '/profile/templete' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/templete/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/profile/templete/index.vue'),
            /* no children */
            meta: {
              "title": "个人中心-已登录",
              "i18n": "menus.infoLogin",
              "showFooter": true,
              "showBackground": true,
              "backgroundColor": "#f5f6f7"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/publish',
    /* internal name: '/publish' */
    /* no component */
    children: [
      {
        path: '',
        name: '/publish/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/publish/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/recharge',
    /* internal name: '/recharge' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recharge/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/recharge/index.vue'),
        /* no children */
        meta: {
          "title": "充值",
          "i18n": "menus.info",
          "showFooter": false,
          "showBackground": false,
          "backgroundColor": "#ffffff"
        }
      },
      {
        path: 'result',
        /* internal name: '/recharge/result' */
        /* no component */
        children: [
          {
            path: '',
            name: '/recharge/result/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/recharge/result/index.vue'),
            /* no children */
            meta: {
              "title": "充值中",
              "i18n": "menus.info",
              "showFooter": false,
              "showBackground": false,
              "backgroundColor": "#ffffff"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/recommend',
    /* internal name: '/recommend' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recommend/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/recommend/index.vue'),
        /* no children */
        meta: {
          "title": "推荐",
          "i18n": "menus.recommend",
          "showFooter": true,
          "hideHeader": true,
          "backgroundColor": "#000000"
        }
      }
    ],
  },
  {
    path: '/search',
    /* internal name: '/search' */
    /* no component */
    children: [
      {
        path: '',
        name: '/search/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/search/index.vue'),
        /* no children */
        meta: {
          "title": "搜索页面",
          "i18n": "menus.search",
          "backgroundColor": "#ffffff"
        }
      }
    ],
  },
  {
    path: '/setting',
    /* internal name: '/setting' */
    /* no component */
    children: [
      {
        path: '',
        name: '/setting/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/setting/index.vue'),
        /* no children */
        meta: {
          "title": "设置",
          "i18n": "menus.setting"
        }
      },
      {
        path: 'security',
        /* internal name: '/setting/security' */
        /* no component */
        children: [
          {
            path: '',
            name: '/setting/security/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/setting/security/index.vue'),
            /* no children */
            meta: {
              "title": "账号与安全",
              "i18n": "menus.security"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/share',
    /* internal name: '/share' */
    /* no component */
    children: [
      {
        path: '',
        name: '/share/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/share/index.vue'),
        /* no children */
        meta: {
          "title": "进入官网",
          "hideHeader": true,
          "showBackground": false
        }
      }
    ],
  },
  {
    path: '/statistics',
    /* internal name: '/statistics' */
    /* no component */
    children: [
      {
        path: '',
        name: '/statistics/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/statistics/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/theater',
    /* internal name: '/theater' */
    /* no component */
    children: [
      {
        path: '',
        name: '/theater/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/theater/index.vue'),
        /* no children */
        meta: {
          "title": "剧场",
          "i18n": "menus.home",
          "showFooter": true
        }
      },
      {
        path: 'series',
        /* internal name: '/theater/series' */
        /* no component */
        children: [
          {
            path: '',
            name: '/theater/series/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/theater/series/index.vue'),
            /* no children */
            meta: {
              "title": "剧集",
              "i18n": "menus.series",
              "hideHeader": true,
              "showFooter": false,
              "navbarFontColor": "#fff",
              "backgroundColor": "#000000"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/wallet',
    /* internal name: '/wallet' */
    /* no component */
    children: [
      {
        path: '',
        name: '/wallet/',
        component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/wallet/index.vue'),
        /* no children */
        meta: {
          "title": "我的余额",
          "i18n": "menus.info",
          "showFooter": false,
          "showBackground": false,
          "backgroundColor": "#ffffff"
        }
      },
      {
        path: 'cashout',
        /* internal name: '/wallet/cashout' */
        /* no component */
        children: [
          {
            path: '',
            name: '/wallet/cashout/',
            component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/wallet/cashout/index.vue'),
            /* no children */
            meta: {
              "title": "提现",
              "i18n": "menus.info",
              "showFooter": false,
              "showBackground": false,
              "backgroundColor": "#ffffff"
            }
          },
          {
            path: 'records',
            /* internal name: '/wallet/cashout/records' */
            /* no component */
            children: [
              {
                path: '',
                name: '/wallet/cashout/records/',
                component: () => import('D:/Colin/work/xlr.-legendary-service-tool/web/mall_web/frontend/src/views/wallet/cashout/records/index.vue'),
                /* no children */
                meta: {
                  "title": "提现记录",
                  "i18n": "menus.info",
                  "showFooter": false,
                  "showBackground": false,
                  "backgroundColor": "#ffffff"
                }
              }
            ],
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

